import noticeManager from "./notice-manager"

export default noticeManager